export default "__VITE_ASSET__2c14ef33__"